import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "source"]

  static values = {
    successContent: String,
    successDuration: {
      type: Number,
      default: 2000,
    },
  }

  connect() {
    this.originalContent = this.buttonTarget?.innerHTML || ""
  }

  copy(event) {
    event.preventDefault()

    const button = event.currentTarget
    const mode = button.dataset.clipboardModeValue
    let text = ""

    if (mode === "all") {
      text = this.sourceTargets.map((el) => this.extractText(el)).join("\n")
    } else if (button.dataset.clipboardCodeValue) {
      text = button.dataset.clipboardCodeValue.trim()
    } else {
      const source = this.findClosestSource(button)
      if (source) text = this.extractText(source)
    }

    if (!text) return

    navigator.clipboard.writeText(text).then(() => this.copied(button, mode))
  }

  extractText(el) {
    return el?.value?.trim() || el?.textContent?.trim() || ""
  }

  findClosestSource(button) {
    const container = button.closest("[data-controller='clipboard']")
    return container?.querySelector("[data-clipboard-target='source']")
  }

  copied(button, mode) {
    if (this.timeout) clearTimeout(this.timeout)

    button.setAttribute("disabled", "")
    button.classList.remove("bg-primary-700", "dark:bg-primary-opaque-100")
    button.classList.add("bg-primary-600", "dark:bg-primary-100")

    this.timeout = setTimeout(() => {
      button.removeAttribute("disabled")
      button.classList.remove("bg-primary-600", "dark:bg-primary-100")
      button.classList.add("bg-primary-700", "dark:bg-primary-opaque-100")
    }, this.successDurationValue)
  }
}
